import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-left\"><path d=\"m6 12-6-6 6-6\" class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(9 6)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol